/**
 * @author czy
 * 功能：账套管理页面
 */

import { Service } from '@/tools'

export class InventoryCalculateService<T extends TSettle.InventoryCalculate> extends Service {
  constructor(path: string) {
    super()
    this.setPathPrefix(path)
  }

  private post2<P extends TCommon.ApiVersion = 'v1'>(url: `${P}/${keyof TSettle.InventoryCalculate}`, data?: TCommon.Json, toast?: string) {
    return this.post(url, data, toast)
  }

  /**
   * 分页查询商品成本
   * /api/settle/inventoryCalculate/v1/pageGoodsCostList
   */
  pageGoodsCostList = <K extends T['ApiPageGoodsCostList']>(data: K['req']): Promise<K['res']> => this.post2('v1/ApiPageGoodsCostList', data)

  /**
   * 查询商品成本明细列表
   * /api/settle/inventoryCalculate/v1/getGoodsCostDetailList
   */
  getGoodsCostDetailList = <K extends T['ApiGetGoodsCostDetailList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetGoodsCostDetailList', data)

  /**
   * 查询商品成本明细期初和期末
   * /api/settle/inventoryCalculate/v1/getGoodsCostBeginToEnd
   */
  getGoodsCostBeginToEnd = <K extends T['ApiGetGoodsCostBeginToEnd']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiGetGoodsCostBeginToEnd', data)

  /**
   * 分页查询商品库存(按明细-按仓汇总-按品汇总)
   * /api/settle/inventoryCalculate/v1/pageGoodsInventoryList
   */
  pageGoodsInventoryList = <K extends T['ApiPageGoodsCostList']>(data: K['req']): Promise<K['res']> =>
    this.post2('v1/ApiPageGoodsInventoryList', data)
}
